import { Component, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ActivatedRoute, NavigationStart, Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { PolicyManagementFilterAPIStatusRes, PolicyManagementFilters } from 'src/app/models/interface/cam.interface';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { PolicyManagementService } from 'src/app/services/dataLayer/CAM/policy-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { PolicyContentService } from '../../services/policy-content.service';
import { NgSwitch, NgSwitchCase, NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCheckbox } from '@angular/material/checkbox';
import { ContentService } from '../../services/content.service';
import { WaitingComponent } from 'src/app/shared/components/waiting/waiting.component';
interface FoodNode {
  name: string;
  children?: FoodNode[];
  navigate: string;
  expandable?: boolean;
}
@Component({
    selector: 'app-policy-management',
    templateUrl: './policy-management.component.html',
    styleUrls: ['./policy-management.component.scss'],
  imports: [NgSwitch, NgSwitchCase, ReactiveFormsModule, MatIcon, NgIf, MatFormField, MatSelect, MatOption, MatSuffix, NgFor, CamEmptyStateComponent, MatButton, RouterLinkActive, RouterLink, RouterOutlet, CdkScrollable, MatDialogContent, MatDialogActions, MatProgressSpinner, MatCheckbox, WaitingComponent]
})
export class PolicyManagementComponent implements OnInit {
  dataSource: FoodNode[];
  userId: string = '';
  guid: string = "";
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  totalPages: number = 0;
  IsShow:boolean=true;
  policyManagementListsModel: FormGroup;
  policyManagementLists: any = { pipe: [], all: [] };
  getProdectData: { pipe: any[]; all: any[] } = {
    pipe: [
      { Product_code: 'AIR ', Is_Access: true, Product_Name: 'Flight' },
      { Product_code: 'OTH ', Is_Access: true, Product_Name: 'Other Products' }
    ],
    all: [
      { Product_code: 'AIR ', Is_Access: true, Product_Name: 'Flight' },
      { Product_code: 'CCR ', Is_Access: true, Product_Name: 'Car' },
      { Product_code: 'HHL ', Is_Access: true, Product_Name: 'Hotel' },
      { Product_code: 'OTH ', Is_Access: true, Product_Name: 'Other Products' }
    ]
  };
  travelCategoryObj: any = {
    travelCategory: [] as { ID: string | number; Name: string }[],
  }
  commonObj: any = {
    STATE: "EMPTY",
    policyID: this._ActivatedRoute.snapshot.queryParams['enc'] ?? "",
    input: "",
    sortBy: "",
    policyRef: {},
    isSubmitting: false,
    isFilterOpened: false,
    filterAppliedOn: [
      { "ID": 1, "Name": "Corporate" },
      { "ID": 2, "Name": "Corporate-Branch" },
      { "ID": 3, "Name": "Department" },
      { "ID": 4, "Name": "Designation" },
      { "ID": 5, "Name": "Grade" },
      { "ID": 6, "Name": "Traveler" }
    ],
  }
  TREE_DATA: FoodNode[] = [
    {
      name: 'Company Profiling',
      children: [
        { name: 'Policy configuration', navigate: `/cam/policy-management/policy-configuration` },
        { name: 'Policy criteria', navigate: `/cam/policy-management/policy-criteria` },
        { name: 'Change rules', navigate: `/cam/policy-management/change-rule` },
        // { name: 'Upgrade policy', navigate: `/cam/policy-management/upgrade-policy` },
      ],
      navigate: '/cam/policy-management',
      expandable: true
    },
  ];
  selectionWarningModelRef!: MatDialogRef<any, any>;
  filterModalRef!: MatDialogRef<any, any>;
  postFilterData!: PolicyManagementFilters;
  private destroy$ = new Subject<void>();
  content:any;
  manageTravelerContent:any;
  constructor(private _FormBuilder: FormBuilder, private _CamApiService: CamService, public _ApiService: ApiService, private _Router: Router, private _CryptoService: CryptoService, public _ActivatedRoute: ActivatedRoute, private _MatDialog: MatDialog, private _ToastrApiService: ToastrApiService, private _ViewContainerRef: ViewContainerRef, private _CompanyManagementService: CompanyManagementService, private _PolicyManagementService: PolicyManagementService,private policyContentService:PolicyContentService,private readonly manageTravelercontentService: ContentService,) {
    this.policyManagementListsModel = this._FormBuilder.group({
      langCode: new FormControl<string>('en'),
      searchValue: new FormControl<string>(''),
      sortOption: new FormControl<string>(''),
      currentPage: new FormControl<number>(1),
      pageSize: new FormControl<number>(15),
      filterMarketType: this._FormBuilder.group({
        DOM: new FormControl<boolean>(false),
        INT: new FormControl<boolean>(false),
      }),
      filterProductCode: this._FormBuilder.group({
        ['AIR ']: new FormControl<boolean>(false),
        ['CCR ']: new FormControl<boolean>(false),
        ['HHL ']: new FormControl<boolean>(false),
        ['OTH ']: new FormControl<boolean>(false),
      }),
      filterAppliedOn: this._FormBuilder.group(
        this.commonObj.filterAppliedOn.reduce((acc: any, item: any) => {
          acc[item.ID] = new FormControl<boolean>(false);
          return acc;
        }, {})
      ),
      filterSelectedTravelCategory: this._FormBuilder.group(
        this.travelCategoryObj.travelCategory.reduce((acc: any, item: any) => {
          const key = `${item.ID}::${item.Name}`;
          acc[key] = new FormControl<boolean>(false);
          return acc;
        }, {})
      ),
    });
    this.dataSource = this.TREE_DATA;
    this.dataSource.forEach(($: any, $index: number) => {
      $.expandable = $index == 0 ? true : false;
    })
    this._Router.events.subscribe(($router: any) => {
      if ($router instanceof NavigationStart) {
        this.routerTrigger($router.url);
      }
    })
  }
  handleEvent(event: string) {
    this._Router.navigate(['/cam/policy-management/policy-configuration']);
    this.commonObj.STATE = 'ROUTE';
    this._PolicyManagementService.policy_management_addNew('Add', this.policyManagementLists.pipe.length)//GTM use
  }
  ngOnInit(): void {
    this._CamApiService.resetPolicyFormsMode();
    this.policyContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });

    this.manageTravelercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.manageTravelerContent = res;
    });

    this.routerTrigger(this._Router.routerState.snapshot.url);
    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    this.policyManagementListsModel.get('searchPolicyValue')?.valueChanges.pipe(debounceTime(3000), distinctUntilChanged()).subscribe(searchTerm => {

      this.policyManagementLists.pipe = this.policyManagementLists.all.filter(($policy: any) => [
        $policy?.TravelPolicy_Title?.toLocaleLowerCase() ?? "",
        $policy?.TravelCategory?.toLocaleLowerCase() ?? "",
        ($policy?.TravelCategoryID !== undefined && $policy?.TravelCategoryID !== null ? String($policy.TravelCategoryID).toLocaleLowerCase() : ""),
        $policy?.CompanyID?.toLocaleLowerCase() ?? "",
        $policy?.AppliedOn?.toLocaleLowerCase() ?? "",
        $policy?.MarketType?.toLocaleLowerCase() ?? "",
        $policy?.Product_Code?.toLocaleLowerCase() ?? ""
      ].join("").includes(searchTerm));
    });
    this.policyManagementListsModel.get('searchValue')?.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value: string) => {

      this.applyFilters("search");
      this._PolicyManagementService.policy_management_search('Policy Management Landing', value, this.policyManagementLists.pipe?.length)//GTM use

    });

    

  }
  routerTrigger(url: string) {

    this.commonObj.policyID = this._ActivatedRoute.snapshot.queryParams['enc'] ?? "";
    if (url == "/cam/policy-management") {
      this.applyFilters("");
    } else {
      this.commonObj.STATE = "ROUTE";
    }
  }
  private pageLandingCalled = false;
  getPolicyApiHit() {
    this.commonObj.STATE = 'WAITING';
    this._CamApiService.getPolicyManagementFilters(this.postFilterData).then(($: PolicyManagementFilterAPIStatusRes) => {
      this.policyManagementLists.pipe = $?.data;
      this.policyManagementLists.all = $?.data;
      this.totalPages = $?.meta?.totalPages || 0;

      // build dynamic Travel Category list from API data
      if (!this.travelCategoryObj.travelCategory?.length) {
        const travelCategoryMap = new Map<
          string,
          { ID: string | number; Name: string }
        >();

        (this.policyManagementLists.all || []).forEach((policy: any) => {
          const id = policy?.travelCategoryType;
          const name = policy?.travelCategory;

          if (id !== null && id !== undefined && !!name) {
            const key = String(name).trim(); // unique by travelCategory name

            if (!travelCategoryMap.has(key)) {
              travelCategoryMap.set(key, {
                ID: id,
                Name: key,
              });
            }
          }
        });

        this.travelCategoryObj.travelCategory = Array.from(
          travelCategoryMap.values()
        );

        // rebuild Travel Category filter controls dynamically
        const travelCategoryGroup = this._FormBuilder.group(
          this.travelCategoryObj.travelCategory.reduce(
            (acc: any, item: any) => {
              const key = `${item.ID}::${item.Name}`;
              acc[key] = new FormControl<boolean>(false);
              return acc;
            },
            {}
          )
        );

        this.policyManagementListsModel.setControl(
          'filterSelectedTravelCategory',
          travelCategoryGroup
        );
      }
      this.commonObj.STATE = !!$.meta.totalCount ? "LIST" : "EMPTY";
      this.filterModalRef?.close();

      //GTM
      if (!this.pageLandingCalled) {

        this.pageLandingCalled = true;
        this._PolicyManagementService.page_landing(
          'Policy Management',
          this.policyManagementLists.pipe.length,
          'Policy Management Workflow'
        );

        this._PolicyManagementService.policyListValue.next(this.policyManagementLists.pipe)//GTM use

      }
    }, () => {
      this.commonObj.STATE = 'EMPTY';
    })



  }
  edit(policyID: number, clickEve: boolean) {
    if (!clickEve) {
      this._PolicyManagementService.policy_management_addNew('View', this.policyManagementLists.pipe.length)//GTM use
    } else {
      this._PolicyManagementService.policy_management_editRemove('Policy Management Landing', 'Edit','Edit', this.policyManagementLists.pipe.length)//GTM use
    }
    setTimeout(() => {
      this.commonObj.policyID = this._ActivatedRoute.snapshot.queryParams['enc'] ?? "";
    }, 1000);
    this._Router.navigate(["/cam/policy-management/policy-configuration"], {
      queryParams: { enc: this._CryptoService.encryptData({ policyID }) }
    })

    

    this._CamApiService.setPolicyFormMode('edit');
  }
  deletePolicyModel(template: TemplateRef<any>, policy: any) {
    this.commonObj.policyRef = policy;
    this.selectionWarningModelRef = this._MatDialog.open(template, { panelClass: 'meet-greet-confirm-changes', disableClose: true, autoFocus: false });
    this._PolicyManagementService.policy_management_editRemove('Policy Management Landing', 'Remove','Remove', this.policyManagementLists.pipe.length)//GTM use

  }
  openFilter(template: TemplateRef<any>) {
    this.filterModalRef = this._MatDialog.open(template, { panelClass: 'custom-popup-gen-policy-filter-popup', disableClose: false, autoFocus: false, backdropClass: 'custom-popup-backdrop-bg-transparent' });
    this.filterModalRef.afterOpened().subscribe(() => {
      this.commonObj.isFilterOpened = true;
    })
    this.filterModalRef.afterClosed().subscribe(() => {
      this.commonObj.isFilterOpened = false;
    })

    this._PolicyManagementService.policy_management_filter('Policy Management Landing', 'filter')//GTM use
  }
  closeSearch() {
    this.policyManagementListsModel.get("searchValue")?.setValue("");
    this.applyFilters("");
  }
  policyDelete() {
    this.commonObj.isSubmitting = true;
    this._PolicyManagementService.policy_remove_cancelProceed('Proceed', 'Confirm')//GTM use
    this._CamApiService.deletePolicy(this.commonObj.policyRef.travelPolicy_Id).then(($res: any) => {
      this._ToastrApiService.show('success', "Policy management has been delete successfully!");
      this._PolicyManagementService.policy_remove_success('policy Remove PopUp', 'Confirm')//GTM use
      this.selectionWarningModelRef.close();
      this.commonObj.isSubmitting = false;
      this.routerTrigger(this._Router.routerState.snapshot.url);
    }).catch((e) => {
      if (e.error.status == "Failed") {
        this._ToastrApiService.show('error', e.error.message);
        this.commonObj.isSubmitting = false;
        this.selectionWarningModelRef.close();
        this._PolicyManagementService.view_error_message(e?.error?.message,e?.error?.code)
      }
      this._PolicyManagementService.view_error_message(e?.error?.message,e?.error?.code)
      this.commonObj.isSubmitting = false;
    })
  }
  redirect(url: string) {
     this._PolicyManagementService.policy_management();
    if(url == '/cam/policy-management/change-rule'){
      // this._PolicyManagementService.policy_upgrade_Change();
    }
    this._Router.navigate([url], {
      queryParams: {
        enc: !!this.commonObj.policyID ? this.commonObj.policyID : (this._ActivatedRoute.snapshot.queryParams['enc'] ?? "")
      }
    })

  }
  applyFilters(key: string): void {
    if(key == "filter"){
      this.policyManagementListsModel.get('currentPage')?.setValue(1);
    }
    const raw = this.policyManagementListsModel.value;
    let filterMarketType = Object.entries(raw.filterMarketType ?? {}).filter(([_, v]) => !!v).map(([k]) => k);
    let filterProductCode = Object.entries(raw.filterProductCode ?? {}).filter(([_, v]) => !!v).map(([k]) => k);
    let filterAppliedOn = Object.entries(raw.filterAppliedOn ?? {}).filter(([_, v]) => !!v).map(([k]) => '' + k);
    let filterSelectedTravelCategory = Array.from(
      new Set(
        Object.entries(raw.filterSelectedTravelCategory ?? {})
          .filter(([_, v]) => !!v)
          .map(([k]) => '' + k.split('::')[0]) // send only ID part to API
      )
    );
    const payload = {
      langCode: raw.langCode,
      searchValue: raw.searchValue,
      sortOption: raw.sortOption,
      currentPage: raw.currentPage,
      pageSize: raw.pageSize,
      filterMarketType,
      filterProductCode,
      filterAppliedOn,
      filterSelectedTravelCategory
    };
    this.postFilterData = payload;
    this.getPolicyApiHit();

    if(raw.sortOption){
      this._PolicyManagementService.policy_management_sortoptionSelect('Policy Management Landing', raw.sortOption)//GTM use
    }


  }

  closePopup() {
    this.selectionWarningModelRef.close();
    this._PolicyManagementService.policy_remove_cancelProceed('Cancel', 'Cancel')//GTM use
  }

  sortBy() {
    this._PolicyManagementService.policy_management_sort('Policy Management Landing', 'sort')//GTM use
  }
  onCheckboxTouched(key: string | number): void {
    // kept for backwards-compat with template bindings (no longer used to build payload)
  }

  menuName(route: any) {
    // GTM Event
    // this._PolicyManagementService.policy_management();
    // First navigate
    // this.redirect(route.navigate);
  
  }
  addNewPolicy() {
    this._PolicyManagementService.policy_management_addNew('Add', this.policyManagementLists.pipe.length)//GTM use
    this._CamApiService.setPolicyFormMode('add');
    // navigation
    this._Router.navigate([
      '/cam/policy-management/policy-configuration'
    ]);
  }


  apply() {
    const raw = this.policyManagementListsModel.value;
      this._PolicyManagementService.policy_management_filterApply('Policy Management Landing','Apply',this.postFilterData)//GTM use

  }

  getProductName(productCode: string | undefined | null): string {
    if (productCode == null || productCode === '') return 'NA';
    const code = String(productCode).trim();
    const product = this.getProdectData.all.find(
      (p: any) => (p.Product_code && String(p.Product_code).trim()) === code
    );
    return product?.Product_Name ?? productCode ?? 'NA';
  }

  getSerialNumber(index: number): number {
    const currentPage = this.policyManagementListsModel.get('currentPage')?.value ?? 1;
    const pageSize = this.policyManagementListsModel.get('pageSize')?.value ?? 15;
    return (currentPage - 1) * pageSize + index + 1;
  }

  prevPage() {
    const current = this.policyManagementListsModel.get('currentPage')?.value;
    if (current > 1) {
      this.policyManagementListsModel.patchValue({ currentPage: current - 1 });
      this.applyFilters("");
    }
  }

  nextPage() {
    const current = this.policyManagementListsModel.get('currentPage')?.value;
    if (current < this.totalPages) {
      this.policyManagementListsModel.patchValue({ currentPage: current + 1 });
      this.applyFilters("");
    }
  }

  getAppliedOnName(policy: any): string {
    const appliedOnValue = policy?.appliedOn ?? policy?.AppliedOn;

    if (appliedOnValue === null || appliedOnValue === undefined || appliedOnValue === '') {
      return 'NA';
    }

    const mapSingle = (value: string | number): string | null => {
      const idNum = Number(value);
      const byId = this.commonObj.filterAppliedOn.find((item: any) => item.ID === idNum);
      if (byId) {
        return byId.Name ==='Corporate-Branch'? 'Corporate-Office location': byId.Name;
      }

      const lower = String(value).toLowerCase();
      const byName = this.commonObj.filterAppliedOn.find(
        (item: any) => String(item.Name).toLowerCase() === lower
      );
      return byName ? byName.Name : null;
    };

    if (typeof appliedOnValue === 'string' && appliedOnValue.includes(',')) {
      const parts = appliedOnValue.split(',').map(p => p.trim()).filter(p => !!p);
      const names = parts
        .map(part => mapSingle(part) ?? part)
        .filter(p => !!p);
      return names.length ? names.join(', ') : 'NA';
    }

    return mapSingle(appliedOnValue) ?? String(appliedOnValue);
  }
}
